import { closeMenu } from '../menu/menu-btns'

const searchWrapper = document.querySelector('.site-search-wrapper')
const searchInput = searchWrapper.querySelector('.main-search-input')

export function closeSearch() {
    searchInput.value = ''
    searchWrapper.classList.remove('block!')
    return
}

function toggleSearchRecommendations() {
    console.log('toggleSearchRecommendations')
    const searchResults = document.querySelector('.relevanssi-live-search-results')
    const searchRecommendations = document.querySelector('#recommended-search-results')
    if (!searchResults || !searchRecommendations) return

    if (searchResults.classList.contains('relevanssi-live-search-results-showing')) {
        searchRecommendations.classList.add('hidden!')
    } else {
        searchRecommendations.classList.remove('hidden!')
    }
}

document.addEventListener('click', function (e) {
    // Search toggle
    if (e.target.classList.contains('search-toggle')) {
        searchWrapper.classList.toggle('block!')
        closeMenu()

        searchInput.focus()
    }

    if (e.target.classList.contains('search-overlay') || e.target.classList.contains('close-search')) {
        closeSearch()
    }
})

document.addEventListener('keyup', function (e) {
    if (e.target.classList.contains('main-search-input')) {
        if (e.key === 'Escape') {
            closeSearch()
        }
        toggleSearchRecommendations()
    }
})
